import { Modal } from "antd";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";

import help1 from "../../../../../assets/multipostingHelper1.png";
import help2 from "../../../../../assets/multipostingHelper2.png";
import help3 from "../../../../../assets/multipostingHelper3.png";

const Content = styled.div`
  padding: 30px;
  max-height: 600px;
  overflow: scroll;
`;

const Title = styled.p`
  margin: 0px;
  font-size: 22px;
  margin-top: 10px;
  font-weight: bold;
  color: ${({ theme }) => theme["@gray-80"]};
  text-align: center;
  margin-bottom: 20px;
`;

const Item = styled.span`
  color: ${({ theme }) => theme["@primary"]};
  font-weight: bold;
`;

const Subtitle = styled.p`
  margin: 0px;
  font-size: 16px;
  color: ${({ theme }) => theme["@gray-80"]};
  text-align: left;
  margin-bottom: 20px;
`;

const TitleText = styled.p`
  margin: 0px;
  font-size: 12px;
  font-weight: bold;
  color: ${({ theme }) => theme["@gray-80"]};
  text-align: left;
`;

const SubtitleText = styled.p`
  margin: 0px;
  font-size: 12px;
  color: ${({ theme }) => theme["@gray-80"]};
  text-align: left;
  margin-left: 20px;
`;

const CustomButton = styled.p`
  font-size: 12px !important;
  color: ${({ theme }) => theme["@primary"]}!important;

  &:hover {
    cursor: pointer;
  }
`;

const MultipostingModalHelper = () => {
  const [
    showMultipostingHelperModal,
    setShowMultipostingHelperModal
  ] = React.useState(false);
  const { t } = useTranslation();
  return (
    <div>
      <CustomButton onClick={() => setShowMultipostingHelperModal(true)}>
        {t("opportunity:wizard.multiposting.integrations.helper.howTo")}
      </CustomButton>
      <Modal
        visible={showMultipostingHelperModal}
        width={770}
        footer={null}
        destroyOnClose
        onCancel={() => setShowMultipostingHelperModal(false)}
      >
        <Content>
          <Title>
            {t("opportunity:wizard.multiposting.integrations.helper.title")}
          </Title>
          <Subtitle>
            {t("opportunity:wizard.multiposting.integrations.helper.subtitle")}
          </Subtitle>
          <TitleText>
            <Item>1.</Item>{" "}
            {t(
              "opportunity:wizard.multiposting.integrations.helper.item1.title"
            )}
          </TitleText>
          <SubtitleText>
            <Item>a.</Item>{" "}
            <Trans i18nKey="opportunity:wizard.multiposting.integrations.helper.item1.a">
              Ve al Perfil de tu empresa y selecciona la Tab
              <b>“Vinculación de cuentas”</b>.
            </Trans>
          </SubtitleText>
          <SubtitleText>
            <Item>b.</Item>{" "}
            <Trans i18nKey="opportunity:wizard.multiposting.integrations.helper.item1.b">
              Luego haz click en el botón <b>“Conectar”</b> del portal que
              quieras vincular.
            </Trans>
          </SubtitleText>
          <br />
          <img src={help1} alt="Help1" />
          <br />
          <br />
          <br />
          <TitleText>
            <Item>2.</Item>{" "}
            {t(
              "opportunity:wizard.multiposting.integrations.helper.item2.title"
            )}
          </TitleText>
          <SubtitleText>
            <Item>a.</Item>{" "}
            {t("opportunity:wizard.multiposting.integrations.helper.item2.a")}
          </SubtitleText>
          <SubtitleText>
            <Item>b.</Item>{" "}
            {t("opportunity:wizard.multiposting.integrations.helper.item2.b")}
          </SubtitleText>
          <SubtitleText>
            <Item>c.</Item>{" "}
            <Trans i18nKey="opportunity:wizard.multiposting.integrations.helper.item2.c">
              En El Paso 5 de tu nueva vacante en Worcket, busca el portal en el
              que hayas creado tu vacante. Si ya tenías tu vacante creada, no te
              preocupes, puedes scrolear hasta el módulo
              <b>Multiposting</b>.
            </Trans>
          </SubtitleText>
          <SubtitleText>
            <Item>d.</Item>{" "}
            <Trans i18nKey="opportunity:wizard.multiposting.integrations.helper.item2.d">
              Haz click en <b>“Ingresar link”</b>
            </Trans>
          </SubtitleText>
          <br />
          <img src={help2} alt="Help2" />
          <br />
          <br />
          <br />
          <TitleText>
            <Item>3.</Item>{" "}
            {t(
              "opportunity:wizard.multiposting.integrations.helper.item3.title"
            )}
          </TitleText>
          <SubtitleText>
            <Item>a.</Item>{" "}
            <Trans i18nKey="opportunity:wizard.multiposting.integrations.helper.item3.a">
              Haz click en el botón <b>“Integrar“</b>.
            </Trans>
          </SubtitleText>
          <SubtitleText>
            <Item>b.</Item>{" "}
            {t("opportunity:wizard.multiposting.integrations.helper.item3.b")}
          </SubtitleText>
          <br />
          <img src={help3} alt="Help3" />
        </Content>
      </Modal>
    </div>
  );
};

export default MultipostingModalHelper;
